import { type CardRefType } from '@/defs/card'
import { type IconType } from '@/defs/icon'
import { type LabelType } from '@/defs/misc'

export const REC_ROLES = ['card', 'commander', 'partner', 'partnerPair', 'companion', 'combo'] as const
export type RecRoleType = (typeof REC_ROLES)[number]

export const REC_ROLE_DEFAULT: RecRoleType = 'card'

type RecRoleLabelType = LabelType<RecRoleType, { icon: IconType }>
export const REC_ROLE_LABELS: RecRoleLabelType = {
  card: { icon: 'cards', label: 'Card' },
  combo: { icon: 'puzzlePiece', label: 'Combo' },
  commander: { icon: 'chessKing', label: 'Commander' },
  companion: { icon: 'handshake', label: 'Companion' },
  partner: { icon: 'hatCowboy', label: 'Partner' },
  partnerPair: { icon: 'peopleArrows', label: 'Partner Pair' },
}

export type RecRefType = CardRefType & { scryfallId?: string }

export type RecType = RecRefType & {
  category?: string
  count?: number
  defaultOrder?: number
  inclusion?: number
  lift?: number
  numDecks?: number
  onlyBack?: boolean
  onlyFront?: boolean
  onlyPartner?: 'first' | 'second'
  partnerRef?: RecRefType
  potentialDecks?: number
  rank?: number
  reverse?: boolean
  role?: RecRoleType
  saltRec?: number
  scryfallId?: string
  synergy?: number
  trendZscore?: number
}
